/**
 * Helpers de timezone — todo el panel opera con calendar dates de CDMX.
 *
 * Por qué: standup, días libres, sesiones y dashboards razonan "hoy"
 * desde la perspectiva del usuario en México. Si usáramos
 * `toISOString().slice(0,10)` el server (UTC) cambiaría de día a las
 * 18:00 CDMX cada tarde — alguien que entra al panel a las 7pm vería
 * "hoy = mañana" y el sistema le diría "no has hecho tu standup"
 * cuando sí lo hizo.
 *
 * México abolió DST en 2022, así que CDMX está en UTC-6 todo el año
 * (excepto las 4 ciudades de la frontera norte que siguen con DST por
 * razones comerciales; no nos aplican).
 */

export const PANEL_TIMEZONE = "America/Mexico_City";

/** YYYY-MM-DD del "hoy" en CDMX. */
export function todayPanelTz(): string {
  return panelTzDate(new Date());
}

/** YYYY-MM-DD de cualquier Date en la timezone del panel. */
export function panelTzDate(d: Date): string {
  // `en-CA` formatea fechas como YYYY-MM-DD por convención. Combinado
  // con `timeZone`, Intl resuelve a la fecha calendario correcta sin
  // depender del runtime (Workers y browsers ambos lo soportan).
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: PANEL_TIMEZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(d);
}
